// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectPatientTypeView_wrapper__2UR0A","info":"SelectPatientTypeView_info__1_Kkd"};